export default "__VITE_ASSET__BY80n1ce__"